import { Link } from 'react-router-dom';
import { getLocalizedPath } from '../data/i18nRoutes';
import useLocale from '../hooks/useLocale';

/** Internal link that respects FR/EN route pairs and saved locale preference. */
export function LocalizedLink({ to, lang, children, ...rest }) {
  const routeLang = useLocale();
  const locale = lang || routeLang;
  const href = getLocalizedPath(to, locale);
  return (
    <Link to={href} {...rest}>
      {children}
    </Link>
  );
}

export default LocalizedLink;
